import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { GoogleAuthService } from 'src/app/core/services/google-auth.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {

  actionCode: any;

  constructor( private router: Router) { }

  ngOnInit(): void {


  }

  navigateLogin(){

    this.router.navigate(['/login'])
  }
}
